import { Calendar } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';
import type { TimeOption } from '~/components/ContentHeader';

export const LOG_LEVEL_OPTIONS = [
  {
    key: 'ALL SEVERITIES',
    label: i18n.t('label.all_severities')
  },
  { key: 'INFO', label: 'Info' },
  { key: 'ERROR', label: 'Error' },
  { key: 'WARN', label: 'Warn' }
];

export const LOG_TYPE_OPTIONS = [
  {
    key: 'ALL SOURCES',
    label: i18n.t('label.all_sources')
  },
  { key: 'INTERNAL', label: i18n.t('label.digibee_internal') },
  { key: 'LOG_CONNECTOR', label: i18n.t('label.log_connector') }
];

export const TIME_OPTIONS: TimeOption[] = [
  { label: i18n.t('scenes.time_ranges.5_minutes'), value: '5m' },
  { label: i18n.t('scenes.time_ranges.15_minutes'), value: '15m' },
  { label: i18n.t('scenes.time_ranges.1_hour'), value: '1h' },
  { label: i18n.t('scenes.time_ranges.1_day'), value: '1d' },
  {
    label: (
      <>
        <span>{i18n.t('label.custom')}</span>
        <Calendar className='icon-smallest' />
      </>
    ),
    value: 'specific'
  }
];

export const INTERVAL_TO_API_MAP: Record<string, string> = {
  '5m': '5 Minutes',
  '15m': '15 Minutes',
  '1h': '1 Hour',
  '1d': '1 Day',
  'custom-range': 'specific'
};

export const URL_TO_TIME_MAP: Record<string, string> = {
  '5 Minutes': '5m',
  '15 Minutes': '15m',
  '1 Hour': '1h',
  '1 Day': '1d',
  specific: 'custom-range'
};

export const TABLE_COLUMNS = [
  {
    key: 'timestamp',
    label: i18n.t('label.timestamp'),
    sortable: true,
    testId: 'monitor-pipeline-logs-table-column-timestamp'
  },
  {
    key: 'logLevel',
    label: i18n.t('label.severity'),
    testId: 'monitor-pipeline-logs-table-column-severity'
  },
  {
    key: 'logMessage',
    label: i18n.t('label.message'),
    testId: 'monitor-pipeline-logs-table-column-message'
  },
  {
    key: 'pipelineName',
    label: i18n.t('label.pipeline'),
    testId: 'monitor-pipeline-logs-table-column-pipeline'
  },
  {
    key: 'pipelineKey',
    label: i18n.t('label.execution_key'),
    testId: 'monitor-pipeline-logs-table-column-execution-key'
  }
];

export const INPUT_STYLES = {
  inputWrapper:
    'border-1 border-solid border-outline rounded-md hover:!border-gray-400 focus-within:!border-primary py-3.5 px-3 h-[68px]',
  input: 'text-body-regular-md',
  label: '!text-label-md !h-4 !transform-none top-[14px] left-3'
};

export const LOG_LEVEL_STYLES: Record<string, string> = {
  ERROR: 'bg-negative-container text-on-negative-container',
  WARN: 'bg-warning-container text-on-warning-container',
  INFO: 'bg-surface-container-low text-primary'
};

export const DEFAULT_LOG_LEVEL = 'ALL SEVERITIES';
export const DEFAULT_LOG_TYPE = 'ALL SOURCES';
export const DEFAULT_TIME_RANGE = '5 Minutes';
export const DEFAULT_SORT_DIRECTION = 'DESC';

export const LOGS_PER_PAGE = 50;
